import { render, staticRenderFns } from "./NewProjectWizardOptionalButtons.vue?vue&type=template&id=71542533&scoped=true&"
import script from "./NewProjectWizardOptionalButtons.vue?vue&type=script&lang=js&"
export * from "./NewProjectWizardOptionalButtons.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectWizardOptionalButtons.vue?vue&type=style&index=0&id=71542533&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71542533",
  null
  
)

export default component.exports